<!--
    @添加功能模块弹出框
-->
<template>
    <el-dialog title="提示" :visible.sync="visiter" @close="cancel" width="800px" :close-on-click-modal="false" :close-on-press-escape="false">
        <div class="add_system">
			<el-transfer
				style="text-align: left; display: inline-block;"
				v-model="value"
				:props="{
					key: 'id',
					label: 'systemName'
				}"
				filterable
				:titles="['源列表', '便捷入口',]"
				:button-texts="['加入左侧', '加入右侧']"
				:format="{
					noChecked: '${total}',
					hasChecked: '${checked}/${total}'
				}"
				@change="handleChange"
				@right-check-change="handleChangeRight"
				:data="data">
			</el-transfer>
			<!-- <div class="btns">
				<el-button type="primary" @click="customBtn">自定义添加</el-button>
			</div> -->
			<div class="btns">
				<el-button @click="cancel">取消</el-button>
				<el-button type="primary" @click="sure">确定</el-button>
			</div>
			<el-dialog title="添加快捷方式" :visible.sync="visiters" width="500px" append-to-body @close="resetForm('formData')">
				<div class="custom_form">
					<el-form label-width="80px" :model="formData" :rules="rules" ref="formData">
						<el-form-item label="名称：" prop="systemName">
							<el-input v-model="formData.systemName"></el-input>
						</el-form-item>
						<el-form-item label="网址：" prop="systemUrl">
							<el-input v-model="formData.systemUrl"></el-input>
						</el-form-item>
					</el-form>
					<div class="btns">
						<el-button @click="customCancel">取消</el-button>
						<el-button type="primary" @click="customSure('formData')">确定</el-button>
					</div>
				</div>
			</el-dialog>
		</div>
    </el-dialog>
</template>

<script>
import {APIwbconveniententrancegetConvenientConfigList} from '@/server/home-center';
import {apiwbconveniententrancesave,apiwbsystemconfigsave} from '@/server/sys';
export default {
    props:{
		addFundialogVisiter:{
			type:Boolean,
			default:false
		}
	},
    data(){
        return {
            data:[],
            value:[],
			rightList:[],
			chooseList:[],
            formData:{
				systemName:'',
				systemUrl:'',
				systemType:5
			},
			visiters:false,
			rules:{
				systemName:[{ required: true, message: '请输入名称', trigger: 'blur' }],
				systemUrl:[{ required: true, message: '请输入网址', trigger: 'blur' }]
			}
        }
    },
    computed:{
		visiter:{
			get:function(){
				return this.addFundialogVisiter;
			},
			set:function(){
				return this.addFundialogVisiter;
			}
		}
	},
    methods:{
        init(){
            APIwbconveniententrancegetConvenientConfigList({
                page:1,
                rows:100
            }).then(({data})=>{
				this.data=data.rows;
            })
        },
        handleChange(value, direction, movedKeys) {
			this.rightList=movedKeys;
			// console.log(value, direction, movedKeys);
		},
		handleChangeRight(value, direction, movedKeys){
			this.chooseList=value;
			// console.log(value, direction, movedKeys);
		},
		cancel(){
			this.visiter=false;
			this.$emit('addfnclose',1);
		},
		sure(){
			if(this.chooseList.length>0||this.rightList.length==0){
				let temp=[];
				for(let item of this.chooseList){
					let tempObj={};
					tempObj.systemConfigId=item;
					tempObj.customizeStatus=0;
					tempObj.delFlag=0;
					temp.push(tempObj)
				}
				apiwbconveniententrancesave(temp).then((res)=>{
					const {data} = res;
					if(data.code=='1'){
						this.$emit('addfnclose',2);
					}else{
						this.$alert(data.msg);
					}
				})
			}else{
				this.$alert('请选择便捷入口');
			}
		},
		// 自定义添加按钮
		customBtn(){
			this.visiters=true;
			this.cancel();
		},
		customCancel(){
			this.visiter=false;
		},
		customSure(formName){
			this.$refs[formName].validate((valid)=>{
				if(valid){
					apiwbsystemconfigsave(this.formData).then((response)=>{
						if(response.data.code=='1'){
							apiwbconveniententrancesave([{
								systemConfigId:response.data.data.id,
								customizeStatus:1,
								delFlag:0
							}]).then((res)=>{
								const {data} = res;
								if(data.code=='1'){
									this.$message.success('添加成功');
									this.customCancel();
									this.$emit('addfnclose',1);
								}else{
									this.$message.error(data.msg);
								}
							})
						}else{
							this.$message.error(response.dat.msg);
						}
					})
				}else{
					return false;
				}
			})
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		}
    }
}
</script>

<style lang="less" scoped>
.add_system{
	text-align: center;
	.btns{
		margin-top: 20px;
	}
}
.custom_form{
	.btns{
		text-align: center;
	}
}
</style>